<template>
  <div class="detail">
    <div class="top_box">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1">
          {{ info.cid ? "编辑课程" : "创建课程" }}
        </div>
        <div class="right"></div>
      </div>
      <div class="Homeboxtop_nav_tab">
        <span
          style="padding-bottom: 20px"
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.name === tabName }]"
          :key="index"
          @click="tabClick(item)"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
    <div class="main" v-show="tabName === '填写课程介绍'">
      <el-form :inline="false" label-width="125px">
        <el-form-item label="课程名称" :required="true">
          <el-input
            v-model="addData.name.value"
            placeholder="请输入"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="课程价格" :required="true">
          <el-input
            v-model="addData.jg.value"
            placeholder="请输入"
            style="width: 235px"
            @input="addData.jg.value = clearNoNumTwo(addData.jg.value)"
          ></el-input>
          <span style="margin-left: 10px">元</span>
        </el-form-item>
        <!-- <el-form-item label="课程覆盖区域" prop="selectedOptions" :required="true">
                  <v-distpicker :province="address.proviceName" :city="address.cityName" :area="address.areaName" @province="getProvince" @city="getCity" @area="getArea" @selected="onSelected" ></v-distpicker>
                </el-form-item> -->
        <el-form-item label="课程覆盖区域" :required="true">
          <div
            style="display: flex; margin-bottom: 5px"
            v-for="(item, i) in address"
            :key="'001' + i"
          >
            <el-select
              style="margin-right: 10px"
              v-model="address[i].proviceCode"
              :disabled="proviceDisabled"
              @change="
                (val) => {
                  handleProviceChange(val, i,true);
                }
              "
              clearable
              filterable
              placeholder="请选择省"
            >
              <el-option
                v-for="item in proviceList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              style="margin-right: 10px"
              v-model="address[i].cityCode"
              :disabled="cityDisabled"
              @change="
                (val) => {
                  handleCityChange(val, i,true);
                }
              "
              clearable
              filterable
              placeholder="请选择市"
            >
              <el-option
                v-for="item in address[i].cityList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="address[i].areaCode"
              :disabled="areaDisabled"
              @change="
                (val) => {
                  handleAreaChange(val, i);
                }
              "
              clearable
              filterable
              placeholder="请选择区"
            >
              <el-option
                v-for="item in address[i].areaList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-button
              size="small"
              v-if="i != 0 && !areaDisabled"
              style="margin-left: 10px"
              @click="delAddress(i)"
              :disabled="areaDisabled"
              >删除</el-button
            >
          </div>
          <el-button size="small" v-if="!areaDisabled" @click="addAddress"
            >添加</el-button
          >
        </el-form-item>
        <el-form-item label="课程材料" :required="true">
          <el-select
            v-model="addData.mid.value"
            @change="handleMaterial"
            clearable
            filterable
            placeholder="请选择材料"
          >
            <el-option
              v-for="item in materialList"
              :key="item.mid"
              :label="item.mname"
              :value="item.mid"
            >
            </el-option>
            <el-option key="no" label="无材料" value="no">
              <span>无材料</span>
            </el-option>
            <el-option key="add" label="新建材料" value="add">
              <span style="margin-right: 10px">
                <i class="el-icon-plus" />
              </span>
              <span style="color: red">新建材料</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程封面" :required="true">
          <div class="material-upload">
            <div class="uploadBtnMore" style="margin-top: 5px">
              <label for="upload_fm">
                <span size="medium" style="cursor: pointer" round class="temp"
                  >上传封面</span
                >
                <input
                  style="display: none"
                  type="file"
                  accept="image/*"
                  :disabled="addData.fm.canClick"
                  id="upload_fm"
                  name="upload_fm"
                  single
                  ref="ipt_fm"
                  @change="uploadFile_fm"
                />
              </label>
            </div>
            <div class="m-l upload-text" style="line-height: 36px">
              允许上传图片的格式为jpg、jpeg、gif、bmp、png建议尺寸大小为：375 *
              210
            </div>
            <ul class="m-t upload-files">
              <li v-for="(item, i) in addData.fm.value" :key="i + item.fid">
                <img :src="item.previewUrl" alt="" class="img" />
                <img
                  src="./imgs/del.svg"
                  alt=""
                  class="del"
                  v-if="item.previewUrl"
                  @click="delFile(addData.fm.value, i)"
                />
              </li>
            </ul>
          </div>
        </el-form-item>

        <el-form-item label="课程类型" :required="true">
          <coure-type  ref="coureTypeRef" @setCourseType="setCourseType"></coure-type>
        </el-form-item>
        <el-form-item label="教学目的" :required="true">
          <el-input
            v-model="addData.md.value"
            type="textarea"
            resize="none"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="教学要求" :required="true">
                    <el-input v-model="addData.yq.value" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="教学重难点" :required="true">
                    <el-input v-model="addData.nd.value" placeholder="请输入"></el-input>
                </el-form-item> -->
        <el-form-item label="适用年级" :required="true">
          <div class="flex_start">
            <el-checkbox
              :label="'小学'"
              class="one_check"
              :indeterminate="isIndeterminate1"
              @change="CheckedChange1"
              v-model="checkAll1"
              >小学</el-checkbox
            >
            <el-checkbox-group v-model="scope_1">
              <el-checkbox
                v-for="item in list_1"
                :label="item.id"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="flex_start">
            <el-checkbox
              :label="'初中'"
              class="one_check"
              :indeterminate="isIndeterminate2"
              @change="CheckedChange2"
              v-model="checkAll2"
              >初中</el-checkbox
            >
            <el-checkbox-group v-model="scope_2">
              <el-checkbox
                v-for="item in list_2"
                :label="item.id"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="flex_start">
            <el-checkbox
              :label="'高中'"
              class="one_check"
              :indeterminate="isIndeterminate3"
              @change="CheckedChange3"
              v-model="checkAll3"
              >高中</el-checkbox
            >
            <el-checkbox-group v-model="scope_3">
              <el-checkbox
                v-for="item in list_3"
                :label="item.id"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="授课时间安排" :required="true">
          <div class="input-list">
            <p>课时总数</p>
            <el-input
              v-model="addData.course_1.value"
              @input="
                addData.course_1.value = clearNoNumTwo(addData.course_1.value)
              "
              placeholder="请输入"
              style="width: 200px"
            ></el-input>
            <p class="m-l">课时</p>
          </div>
          <div class="input-list">
            <p>课时时长</p>
            <el-input
              v-model="addData.course_2.value"
              @input="
                addData.course_2.value = clearNoNumTwo(addData.course_2.value)
              "
              placeholder="请输入"
              style="width: 200px"
            ></el-input>
            <p class="m-l">分钟</p>
          </div>
          <div class="input-list">
            <p>上课频率</p>
            <el-input
              v-model="addData.course_3.value"
              @input="
                addData.course_3.value = clearNoNumTwo(addData.course_3.value)
              "
              placeholder="请输入"
              style="width: 200px"
            ></el-input>
            <p class="m-l">次/周</p>
          </div>
        </el-form-item>
        <el-form-item label="课程特点" :required="true">
          <div
            style="display: flex; margin-bottom: 5px"
            v-for="(item, i) in addData.td.value"
            :key="'001' + i"
          >
            <el-input
              v-model="addData.td.value[i]"
              placeholder="请输入"
              style="margin-right: 15px"
              maxlength="100"
              show-word-limit
            ></el-input>
            <el-button size="small" @click="delTd(i)">删除</el-button>
          </div>
          <el-button size="small" @click="addTd">添加</el-button>
        </el-form-item>
        <el-form-item label="视频介绍">
          <div class="material-upload" style="margin-top: 8px">
            <div class="uploadBtnMore">
              <label for="upload_cl">
                <div style="cursor: pointer" @click="uploadTool('cltp')">
                  上传视频
                </div>
                <!-- <span size="medium" round class="temp" @change="uploadFile_cl">上传视频</span>
                                <input style="display: none;" type="file" accept="video/*" :disabled="addData.cltp.canClick" id="upload_cl" name="upload_cl" multiple ref="ipt_cl" @change="uploadFile_cl" /> -->
              </label>
            </div>
            <div class="m-l upload-text">
              <p>允许上传视频的格式为 mkv, mp4, avi, rm, rmvb</p>
            </div>
            <ul
              class="m-t upload-files"
              v-if="
                addData.cltp.value &&
                addData.cltp.value.length &&
                addData.cltp.value[0].downloadUrl
              "
            >
              <li
                v-for="(item, i) in addData.cltp.value"
                :key="i + item.fid"
                class="video_li"
              >
                <video
                  class="video-class"
                  v-if="item.downloadUrl != ''"
                  :src="item.downloadUrl || item.downloadUrl"
                  controls
                  controlslist="nodownload"
                  :ref="'videoObj' + i"
                ></video>
                <!-- <p  v-else>视频正在解码中···</p> -->
                <img
                  src="./imgs/del.svg"
                  alt=""
                  class="del"
                  v-if="item.previewUrl"
                  @click="delVideo(addData.cltp.value, i)"
                />
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="课程介绍" :required="true">
          <el-input
            v-model="addData.gs.value"
            type="textarea"
            resize="none"
            :rows="5"
            placeholder="请输入"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="授课教师" :required="true">
          <el-select
            v-model="teacherId"
            clearable
            placeholder="请选择授课教师"
            filterable
          >
            <el-option
              v-for="item in teacherList"
              :key="item.user_id + 'teacherList'"
              :label="item.name"
              :value="item.user_id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <footer>
        <el-button
          style="width: 120px"
          type="primary"
          size=""
          @click="tabName = '上传教案课件'"
          >下一步</el-button
        >
      </footer>
    </div>
    <!--  上传教案和课件区域-->
    <div class="main" v-show="tabName === '上传教案课件'">
      <div class="main-title">
        <img src="./imgs/selfAdd_01.svg" alt="" />
        <p :class="{ require: false }">教案简案及详案</p>
        <div class="uploadBtnMore_pl">
          <label for="upload_cl">
            <div @click="uploadTool('file_1')">选择文件</div>
          </label>
        </div>
      </div>
      <div class="table" style="width: 100%">
        <div class="table-header">
          <div style="width: 15%">序号</div>
          <div style="width: 85%">教学简案及详案</div>
        </div>
        <div
          v-if="addData.file_1.value.length > 0"
          v-for="(item, i) in addData.file_1.value"
          :key="i + '授课课件示例'"
          class="table_2_tr"
        >
          <div class="td-1">{{ i + 1 }}</div>
          <div class="td-2">
            <div class="file">
              <div>
                <img src="./imgs/file.svg" alt="" v-if="item.fid" />
                <img src="./imgs/upload.svg" alt="" v-if="!item.fid" />
                <label :for="'upload_two_' + i" class="pointer">
                  <span size="medium" round class="temp">{{
                    !item.fid ? "上传文件" : item.name
                  }}</span>
                </label>
              </div>
              <a v-if="item.fid" href="javascript:;" @click="previewFile(item)"
                >预览</a
              >

              <a
                v-if="item.fid"
                href="javascript:;"
                @click="uplateName(i, 'file_1', item)"
                >重命名</a
              >

              <a href="javascript:;" style="color: red" @click="delTr(i, 'one')"
                >删除</a
              >
            </div>
          </div>
        </div>
        <div v-if="addData.file_1.value.length == 0" class="table_2_tr">
          <div class="td-1">...</div>
          <div class="td-2">
            <div class="file">
              <div>
                <label>
                  <span class="no_temp" size="medium" round>未上传文件</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-title" style="margin-top: 20px">
        <img src="./imgs/selfAdd_02.svg" alt="" />
        <p :class="{ require: false }">授课课件示例</p>
        <div class="uploadBtnMore_pl" style="margin-left: 75%">
          <label for="upload_cl">
            <div @click="uploadTool('file_2')">选择文件</div>
          </label>
        </div>
      </div>
      <div class="table" style="width: 100%">
        <div class="table-header">
          <div style="width: 15%">序号</div>
          <div style="width: 85%">授课课件实例</div>
        </div>
        <div
          v-if="addData.file_2.value.length > 0"
          v-for="(item, i) in addData.file_2.value"
          :key="i + '授课课件示例'"
          class="table_2_tr"
        >
          <div class="td-1">{{ i + 1 }}</div>
          <div class="td-2">
            <div class="file">
              <div>
                <img src="./imgs/file.svg" alt="" v-if="item.fid" />
                <img src="./imgs/upload.svg" alt="" v-if="!item.fid" />
                <label :for="'upload_two_' + i" class="pointer">
                  <span size="medium" round class="temp">{{
                    !item.fid ? "上传文件" : item.name
                  }}</span>
                </label>
              </div>
              <a v-if="item.fid" href="javascript:;" @click="previewFile(item)"
                >预览</a
              >

              <a
                v-if="item.fid"
                href="javascript:;"
                @click="uplateName(i, 'file_2', item)"
                >重命名</a
              >

              <a href="javascript:;" style="color: red" @click="delTr(i, 'two')"
                >删除</a
              >
            </div>
          </div>
        </div>
        <div v-if="addData.file_2.value.length == 0" class="table_2_tr">
          <div class="td-1">...</div>
          <div class="td-2">
            <div class="file">
              <div>
                <label>
                  <span class="no_temp" size="medium" round>未上传文件</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <el-button style="width: 120px" size="" @click="toIndex()"
          >取消</el-button
        >
        <el-button
          style="margin-left: 20px; width: 120px"
          type="primary"
          size=""
          @click="save()"
          >保存</el-button
        >
      </footer>
    </div>
    <!-- 上传组件 -->
    <res-uploader
      ref="resUploader"
      :visible.sync="upDialogShow"
      @submit="handleUpload"
      :isContinue="isContinue"
      :accept="accept"
    ></res-uploader>
    <!-- 重命名弹框 -->
    <uplate-name
      :visible.sync="renameDialogVisible"
      :nowName="oldFoldName"
      @rename="handleReName"
    ></uplate-name>
  </div>
</template>
<script>
import {
  addCurriculum,
  handleUpdate,
  getMaterialsList,
} from "@/api/mechanismApi/curriculum.js";
import {
  getNextAreaInfo,
  schoolTeacherList,
  getAllAreaInfo,
} from "@/api/user/userCenter";
import util from "@/utils/util.js";
import _ from "lodash";
import UploadService from "@/utils/fileCenter/tencentCloud.upload";
import axios from "axios";
import VDistpicker from "v-distpicker";
import resUploader from "@/components/UploadResource/ResUploader";
import uplateName from "@/components/uplateName.vue";
import coureType from "@/views/components/coureType.vue";
export default {
  props: ["info"],
  components: { VDistpicker, resUploader, uplateName,coureType },
  data() {
    return {
      platformCode: sessionStorage.getItem("platformCode"),
      renameDialogVisible: false,
      upDialogShow: false,
      oldFoldName: "",
      uplateNameType: "",
      uplateNameIndex: "",
      isContinue: true, //是否继续添加
      accept: "", //上传文件的类型
      uploadResourcesType: "", //上传的资源类型
      proviceDisabled: false,
      cityDisabled: false,
      areaDisabled: false,
      teacherList: [],
      proviceList: [], //省列表数据
      address: [
        {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
          cityList:[],//市列表数据
          areaList:[],//区列表数据
        },
      ], //覆盖区域控件选择的地址(默认值)
      editAddress:{},//编辑的地址
      teacherId: "", //授课老师
      addData: {
        name: { value: "", title: "课程名称" },
        jg: { value: "", title: "课程价格" },
        mid: { value: "", title: "课程材料", select: {} },
        fm: { value: [], title: "课程封面", canClick: false },
        md: { value: "", title: "教学目的" },
        check_arr: { value: [], title: "适用年级" },
        course_1: { value: "", title: "课时总数" },
        course_2: { value: "", title: "课时时长" },
        course_3: { value: "", title: "上课频率" },
        td: { value: [], title: "课程特点", skip: true },
        cltp: {
          value: [],
          title: "视频介绍",
          canClick: false,
          skip: true,
        },
        gs: { value: "", title: "课程概述" },
        file_1: {
          value: [],
          title: "教案简案及详案",
          canClick: false,
          skip: true,
        },
        file_2: {
          value: [],
          title: "授课课件示例",
          canClick: false,
          skip: true,
        },
      },
      typeList: JSON.parse(sessionStorage.getItem("courseType")) || [],
      tableData: [],
      tabList: [{ name: "填写课程介绍" }, { name: "上传教案课件" }],
      tabName: "填写课程介绍",
      list_1: [
        { id: "01", label: "一年级" },
        { id: "02", label: "二年级" },
        { id: "03", label: "三年级" },
        { id: "04", label: "四年级" },
        { id: "05", label: "五年级" },
        { id: "06", label: "六年级" },
      ],
      list_2: [
        { id: "11", label: "初一" },
        { id: "12", label: "初二" },
        { id: "13", label: "初三" },
      ],
      list_3: [
        { id: "21", label: "高一" },
        { id: "22", label: "高二" },
        { id: "23", label: "高三" },
      ],
      scope_1: [],
      scope_2: [],
      scope_3: [],
      checkAll1: false,
      checkAll2: false,
      checkAll3: false,
      isIndeterminate1: false,
      isIndeterminate2: false,
      isIndeterminate3: false,
      canClick: false,
      uploadInstance: null,
      userInfo: JSON.parse(window.sessionStorage.getItem("Userlist")) || {},
      materialList: [],
      typeId:"", // 课程类型
      typeName:"", // 课程类型
      subclassId:"", // 小类id
      subclassName:"", // 小类名
    };
  },
  computed: {},
  watch: {
    "info.cid": async function (n, o) {
      console.log("编辑", this.info);
      if (n) {
        let vm = this.addData,
          obj = this.info;
          let coureTypeArry=[]
          if(obj.typeId && obj.typeId!=''){
             coureTypeArry.push(obj.typeId)
          }
          if(obj.subclassId && obj.subclassId!=''){
              coureTypeArry.push(obj.subclassId)
          }
         this.$refs.coureTypeRef.setValue(coureTypeArry)
        if (!obj.resource) obj.resource = [];
        vm.name.value = obj.cname; // 课程名称
        vm.jg.value = obj.price; //课程价格
        if (obj.mid) {
          (vm.mid.value = obj.mid), // 材料id
            (vm.mid.select.mid = obj.mid);
          (vm.mid.select.mname = obj.mname), // 材料名称
            (vm.mid.select.matAuditState = obj.matAuditState); // 材料审核状态
        } else {
          vm.mid.value = "no";
        }
        vm.fm.value = [{ previewUrl: obj.coverUrl }]; // 课程封面
        vm.md.value = obj.teachAims; // 教学目的
        // vm.yq.value = obj.teachRequire; // 教学要求
        // vm.nd.value = obj.teachDifficulty; // 教学重难点
        if (obj.scope && obj.scope != "") {
          vm.check_arr.value = obj.scope.split(","); // 适用年级
        }
        this.scope_1 = vm.check_arr.value.filter(
          (e) => ["01", "02", "03", "04", "05", "06"].indexOf(e) > -1
        );
        this.scope_2 = vm.check_arr.value.filter(
          (e) => ["11", "12", "13"].indexOf(e) > -1
        );
        this.scope_3 = vm.check_arr.value.filter(
          (e) => ["21", "22", "23"].indexOf(e) > -1
        );
        if (obj.teacherInfo) {
          this.teacherId = obj.teacherInfo.personId; // 授课老师
        }
        vm.course_1.value = obj.periodTotal; // 课时总数
        vm.course_2.value = obj.periodTime; // 课时时长
        vm.course_3.value = obj.frequency; // 上课频率
        vm.gs.value = obj.description; // 课程概述
        if (obj.feature && obj.feature != "") {
          vm.td.value = obj.feature.split("<br/>"); // 课程特点
        }
        // 课程覆盖区域
        this.editAddress=obj.coverAreas
        // 课程类型
         this.typeId=obj.typeId || ''
         this.typeName=obj.typeName || ''
         this.subclassId=obj.subclassId || ''
         this.subclassName=obj.subclassName || ''
        vm.cltp.value = obj.resource.filter((e) => e.source == "0"); // 视频介绍
        vm.file_1.value = obj.resource.filter((e) => e.source == "2"); // 教案简案及详案
        vm.file_2.value = obj.resource.filter((e) => e.source == "3"); // 授课课件示例
        if(obj.coverAreas.length>0){
           this.handleAddress(obj.coverAreas)
        }
      } else {
        this.init();
        this.handleDefaultAddress()
      }
    },
    scope_1(n, o) {
      this.checkAll1 = n.length === 6;
      this.isIndeterminate1 = n.length > 0 && n.length < 6;
    },
    scope_2(n, o) {
      this.checkAll2 = n.length === 3;
      this.isIndeterminate2 = n.length > 0 && n.length < 3;
    },
    scope_3(n, o) {
      this.checkAll3 = n.length === 3;
      this.isIndeterminate3 = n.length > 0 && n.length < 3;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 处理输入框小数点两位问题
    clearNoNumTwo(obj) {
      obj = obj.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      if (obj.indexOf(".") < 0 && obj != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        obj = parseFloat(obj);
      }
      let strObj = obj.toString();
      if (strObj.indexOf(".") > -1 && strObj === "0.00") {
        obj = parseFloat(obj).toFixed(1);
      }
      return obj;
    },

    async initData() {
      const { result, data } = await getMaterialsList(
        sessionStorage.getItem("orgId")
      );
      if (result === "000000") {
        this.materialList = data;
      }
      this.handleAreaList();
      this.handleTeacherList();
      this.handleDefaultAddress()
    },
    // 获取授课老师
    async handleTeacherList() {
      let params = {
        top_org_id: sessionStorage.getItem("orgId"),
        page: 1,
        page_size: 500,
        user_type: "1,5",
        need_role: "1",
      };
      let teacherRes = await schoolTeacherList(params);
      if (teacherRes.code === "000000") {
        this.teacherList = teacherRes.result.member_list || [];
      } else {
        this.$message.error("获取老师信息失败");
        return false;
      }
    },
    // 获取所有的地区
    handleAllAreaList() {
      if (sessionStorage.getItem("AllAreaInfo")) return;
      getAllAreaInfo().then((res) => {
        if (res.code == "000000") {
          this.address[0].cityList = res.result;
          this.address[0].areaList = res.result;
          sessionStorage.AllAreaInfo = JSON.stringify(res.result);
        }
      });
    },
    // 刚进入根据用户地区进行地址的默认
   async handleDefaultAddress(){
        const UserlistObj= JSON.parse(sessionStorage.Userlist)
        if(UserlistObj.province_code!='' && UserlistObj.city_code!=''){
          this.proviceDisabled = true;
          this.cityDisabled = true;
          const { code, result } = await getNextAreaInfo({ area_code: UserlistObj.province_code });
          const res = await getNextAreaInfo({ area_code: UserlistObj.city_code });
           this.address.forEach((j) => {
            j.proviceCode = UserlistObj.province_code ||'';
            j.proviceName = UserlistObj.province_name  ||'';
            j.cityCode = UserlistObj.city_code ||'';
            j.cityName = UserlistObj.city_name ||'';
            j.cityList= code == "000000"?result:[];
            j.areaList= res.code == "000000"?res.result:[];
          });
       }else if(UserlistObj.province_code!='' && UserlistObj.city_code==''){
        this.proviceDisabled = true;
         const { code, result } = await getNextAreaInfo({ area_code: UserlistObj.province_code });
             this.address.forEach((j) => {
              j.proviceCode = UserlistObj.province_code ||'';
              j.proviceName = UserlistObj.province_name  ||'';
              j.cityList= code == "000000"?result:[];
            });
            this.proviceDisabled = true;
       }
    },
    //根据区域编码填充地址
    handleAddress(coverAreas){
      let _address=this.address=[]
      for(let i=0;i< coverAreas.length;i++){
          this.handleProviceChange(coverAreas[i].proviceCode,i)
          this.handleCityChange(coverAreas[i].cityCode,i)
          _address.push({
              proviceCode: coverAreas[i].proviceCode,
              proviceName: coverAreas[i].proviceName,
              cityCode:coverAreas[i].cityCode,
              cityName: coverAreas[i].cityName,
              areaCode: coverAreas[i].areaCode,
              areaName: coverAreas[i].areaName,
              cityList:[],//市列表数据
              areaList:[],//区列表数据
          })
      }
    },
    // 过滤选择地址控制
    handleLevel() {
      // this.platformCode='420000'  // 420000  420100   420111
      let AllAreaList = JSON.parse(sessionStorage.getItem("AllAreaInfo")) || [];
      if (AllAreaList.length > 0 && this.platformCode) {
        AllAreaList.forEach((it) => {
          if (it.area_code == this.platformCode && it.area_level == "1") {
            this.proviceDisabled = true;
            this.filterAdress(AllAreaList, it, "1");
            this.handleProviceChange(this.platformCode);
          } else if (
            it.area_code == this.platformCode &&
            it.area_level == "2"
          ) {
            this.proviceDisabled = true;
            this.cityDisabled = true;
            this.filterAdress(AllAreaList, it, "2");
            this.handleProviceChange(it.parent_code);
            this.handleCityChange(this.platformCode);
          } else if (
            it.area_code == this.platformCode &&
            it.area_level == "3"
          ) {
            this.proviceDisabled = true;
            this.cityDisabled = true;
            this.areaDisabled = true;
            let obj = AllAreaList.filter(
              (v) => v.area_code == it.parent_code
            )[0];
            this.handleProviceChange(obj.parent_code);
            this.handleCityChange(it.parent_code);
            this.filterAdress(AllAreaList, it, "3");
          }
        });
      }
    },
    // 对地址控件数据进行填充
    filterAdress(data, it, level) {
      let obj = {};
      if (level == "1") {
        this.address.forEach((j) => {
          j.proviceCode = it.area_code;
          j.proviceName = it.area_name;
        });
      } else if (level == "2") {
        this.address.forEach((j) => {
          j.proviceCode = it.parent_code;
          j.proviceName = data.filter(
            (v) => v.area_code == it.parent_code
          )[0].area_name;
          j.cityCode = it.area_code;
          j.cityName = it.area_name;
        });
      } else {
        this.address.forEach((j) => {
          obj = data.filter((v) => v.area_code == it.parent_code)[0];
          j.proviceCode = data.filter(
            (v) => v.area_code == obj.parent_code
          )[0].area_code;
          j.proviceName = data.filter(
            (v) => v.area_code == obj.parent_code
          )[0].area_name;
          j.cityCode = it.parent_code;
          j.cityName = obj.area_name;
          j.areaCode = it.area_code;
          j.areaName = it.area_name;
        });
      }
    },
    handleAreaList() {
      // 用户中心获取全部省的数据
      getNextAreaInfo({ area_code: "0" }).then((res) => {
        if (res.code == "000000") {
          this.proviceList = res.result;
        }
      });
    },
    //areaCode
    async handleProviceChange(areaCode, i,boolean) {
      if (i >= 0 && boolean) {
        var obj = {};
        obj = this.proviceList.find(function (item) {
          return item.area_code === areaCode;
        });
        if (obj) {
          this.address[i].proviceName = obj.area_name;
          this.address[i].proviceCode = obj.area_code;
        } else {
          this.address[i].proviceName = '';
          this.address[i].proviceCode = '';
        }
        this.address[i].cityCode = "";
        this.address[i].cityName = "";
        this.address[i].areaCode = "";
        this.address[i].areaName = "";
      }
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.address[i].cityList = result;
      }
    },
    async handleCityChange(areaCode, i,boolean) {
      if (i >= 0 && boolean) {
        var obj = {};
        obj = this.address[i].cityList.find(function (item) {
          return item.area_code === areaCode;
        });
        if(obj){
          this.address[i].cityName = obj.area_name;
        } else {
          this.address[i].cityName = '';
        }
        this.address[i].areaCode = "";
        this.address[i].areaName = "";
      }
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.address[i].areaList = result;
      }
    },
    async handleAreaChange(areaCode, i) {
      var obj = {};
      obj = this.address[i].areaList.find(function (item) {
        return item.area_code === areaCode;
      });
      if (i >= 0) {
        this.address[i].areaName = obj.area_name;
      }
    },
    delFile(arr, i) {
      arr.splice(i, 1);
    },
    delVideo(arr, i) {
      this.$set(this.addData.cltp.value, i, {
        fid: "",
        source: "",
        name: "",
        downloadUrl: "",
        previewUrl: "",
        ext: "",
      });
    },
    delTr(i, type) {
      if (type === "one") {
        this.addData.file_1.value.splice(i, 1);
      } else {
        this.addData.file_2.value.splice(i, 1);
      }
    },
    uplateName(i, type, item) {
      this.oldFoldName = item.name;
      this.uplateNameType = type;
      this.uplateNameIndex = i;
      this.renameDialogVisible = true;
    },
    // 文件重命名
    async handleReName(values) {
      this.renameDialogVisible = false;
      this.addData[this.uplateNameType].value[this.uplateNameIndex].name =
        values.name;
    },
    // 上传封面
    async uploadFile_fm(e) {
      this.uploadInstance = new UploadService({
        appType: "khfw",
        userInfo: {
          userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
          platformCode: JSON.parse(window.sessionStorage.getItem("Userlist"))
            .platformCode,
        },
      });
      const sourceFiles = this.$refs.ipt_fm.files;
      this.addData.fm.canClick = true;
      try {
        let promiseList = [];
        for (let i = 0; i < sourceFiles.length; i++) {
          let ext = util.getFileExt(sourceFiles[i]["name"]);
          if (sourceFiles[i]["size"] == 0) {
            //大小为0的文件
            this.$message({
              message: `文件${sourceFiles[i]["name"]}是空文件,自动过滤删除`,
              type: "error",
              duration: 1000,
            });
            continue;
          }
          this.addData.fm.value = [
            {
              name: sourceFiles[i]["name"],
              size: this.formatFileSize(sourceFiles[i].size),
              fileLength: sourceFiles[i].size,
              type: this.getExt(ext),
              ext: ext,
              source: "0",
            },
          ];
          const fn = this.uploadInstance.upload(sourceFiles[i], {
            onProgress: (progress) => {},
          });
          promiseList.push(fn);
        }
        const resArr = await Promise.all(promiseList);
        const markIdx = this.addData.fm.value.length - resArr.length;
        resArr.forEach((res, index) => {
          const itemRes = res.data;
          this.addData.fm.value[markIdx + index].fid = itemRes.fid;
          this.addData.fm.value[markIdx + index].downloadUrl =
            itemRes.downloadUrl;
          if (itemRes.previewUrl) {
            this.addData.fm.value[markIdx + index].previewUrl =
              itemRes.previewUrl;
          } else {
            this.addData.fm.value[markIdx + index].previewUrl =
              itemRes.downloadUrl;
          }
        });
      } catch (error) {
        this.$message({
          message: "上传失败",
          type: "error",
          duration: 1000,
        });
        console.log(error);
      } finally {
        this.addData.fm.canClick = false;
        e.target.value = "";
      }
    },
    // 调用上传的组件
    async uploadTool(type) {
      this.upDialogShow = true;
      if (type == "cltp") {
        this.accept = "video/*";
        this.isContinue = false;
      } else {
        this.accept =
          "audio/*,video/*,image/*,.rar,.zip,.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt";
        this.isContinue = true;
      }
      this.uploadResourcesType = type;
    },
    //  上传教案简案及详案   &   上传授课课件示例
    async handleUpload(paramObj) {
      this.addData.cltp.canClick = true;
      this.upDialogShow = false;
      let source;
      if (this.uploadResourcesType == "cltp") {
        source = "0";
      } else if (this.uploadResourcesType == "file_1") {
        source = "2";
      } else {
        source = "3";
      }
      for (let i = 0; i < paramObj.length; i++) {
        let fileObj = {
          fid: paramObj[i].fid,
          name: paramObj[i].titname,
          fileLength: paramObj[i].fileLength,
          ext: util.getFileExt(paramObj[i].titname),
          source: source,
          downloadUrl: paramObj[i].downloadUrl,
          previewUrl: paramObj[i].previewUrl
            ? paramObj[i].previewUrl
            : paramObj[i].downloadUrl,
        };
        this.addData[this.uploadResourcesType].value.push(fileObj);
      }
    },
    previewFile(item) {
      window.open(item.previewUrl);
    },
    tabClick(item) {
      this.tabName = item.name;
    },
    toIndex() {
      this.$emit("to-index");
    },
    checkFiles(data, text) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].fid) {
          this.$message.error(text + "有未上传教案");
          return false;
        }
        data[i].classHour = i + 1;
      }
      return data;
    },
    save: _.throttle(
      async function () {
        let vm = this.addData;
        vm.check_arr.value = [
          ...this.scope_1,
          ...this.scope_2,
          ...this.scope_3,
        ].sort((a, b) => {
          return a - b;
        });
        if (!util.checkData(vm)) {
          return false;
        }
         if (
          this.typeId == "" 
        ) {
          this.$message.error("请选择课程类型");
          return;
        }
        if (
          this.address[0].proviceCode == "" ||
          this.address[0].proviceName == ""
        ) {
          this.$message.error("请选择课程覆盖区域");
          return;
        }
        if (vm.td.value.length == 0) {
          this.$message.error("请选输入课程特点");
          return;
        }
        let file_1 = this.checkFiles(vm.file_1.value, vm.file_1.title);
        if (!file_1) return false;
        let file_2 = this.checkFiles(vm.file_2.value, vm.file_2.title);
        if (!file_2) return false;
        let file_arr = [...vm.cltp.value, ...file_1, ...file_2];
        // let courseType = this.typeList.filter((e) => e.id === vm.type.value);
        let teacher = this.teacherList.filter(
          (e) => e.user_id === this.teacherId
        )[0];
        this.address.forEach(it=>{
           delete it.cityList
           delete it.areaList
        })
        let params = {
          cname: vm.name.value, // 课程名称
          price: vm.jg.value || 0, // 课程价格
          mid: vm.mid.select.mid, // 材料id
          mname: vm.mid.select.mname, // 材料名称
          matAuditState: vm.mid.select.auditState, // 材料审核状态
          coverUrl: vm.fm.value[0].previewUrl, // 课程封面
          // 授课教师
          typeId: this.typeId, // 课程类型
          typeName: this.typeName, // 课程类型
          subclassId:this.subclassId, // 小类id
          subclassName:this.subclassName, // 小类名称
          teachAims: vm.md.value, // 教学目的
          // teachRequire: vm.yq.value, // 教学要求
          // teachDifficulty: vm.nd.value, // 教学重难点
          scope: vm.check_arr.value.join(","), // 适用年级
          periodTotal: vm.course_1.value, // 课时总数 736
          periodTime: vm.course_2.value, // 课时时长 9
          frequency: vm.course_3.value, // 上课频率 822
          description: vm.gs.value, // 课程概述
          feature: vm.td.value.join("<br/>"), // 课程特点
          resource: file_arr, // 资源
          teacherInfo: {
            // 授课教师
            personId: teacher.user_id || "",
            name: teacher.name || "",
          },
          orgType: "8",
          objectives: "",
          supportingDesc: "",
          teachContent: "",
          enrollment: "",
          coverAreas: this.address,
        };
        if (this.info.cid) {
          params.cid = this.info.cid;
          for(let i=0;i< this.editAddress.length;i++){
             this.address[i].id=this.editAddress[i].id
          }
          console.log("编辑课程保存", params);
          var res = await handleUpdate(params);
          if (res.result === "000000") {
            this.$message.success("编辑成功");
            this.info.cid = null;
            this.init();
            this.$emit("to-init");
            this.toIndex();
          } else {
            this.$message.error("编辑失败");
          }
        } else {
           console.log("新建课程保存", params);
          var res = await addCurriculum(params);
          if (res.result === "000000") {
            this.$message.success("创建成功");
            this.init();
            this.$emit("to-init");
            this.toIndex();
          } else {
            this.$message.error("创建失败");
          }
        }
      },
      3000,
      { leading: true, trailing: false }
    ),
    init() {
      this.tabName = "填写课程介绍";
      this.teacherId = "";
      this.addData = {
        name: { value: "", title: "课程名称" },
        jg: { value: "", title: "课程价格" },
        // address: { value: "", title: "课程覆盖区域" },
        mid: { value: "", title: "课程材料", select: {} },
        fm: { value: [], title: "课程封面", canClick: false },
        // type: { value: "", name: "", title: "课程类型" },
        md: { value: "", title: "教学目的" },
        // yq: { value: "", title: "教学要求" },
        // nd: { value: "", title: "教学重难点" },
        check_arr: { value: [], title: "适用年级" },
        course_1: { value: "", title: "课时总数" },
        course_2: { value: "", title: "课时时长" },
        course_3: { value: "", title: "上课频率" },
        td: { value: [""], title: "课程特点", skip: true },
        cltp: {
          value: [
            {
              fid: "",
              source: "",
              name: "",
              downloadUrl: "",
              previewUrl: "",
              ext: "",
            },
          ],
          title: "视频介绍",
          canClick: false,
          skip: true,
        },
        gs: { value: "", title: "课程概述" },
        file_1: {
          value: [],
          title: "教案简案及详案",
          canClick: false,
          skip: true,
        },
        file_2: {
          value: [],
          title: "授课课件示例",
          canClick: false,
          skip: true,
        },
      };
      this.typeId=''
      this.typeName=''
      this.subclassId=''
      this.subclassName=''
      this.scope_1 = [];
      this.scope_2 = [];
      this.scope_3 = [];
      this.address = [
       {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
          cityList:[],//市列表数据
          areaList:[],//区列表数据
        },
      ];
    },
    CheckedChange1(value) {
      this.scope_1 = value ? ["01", "02", "03", "04", "05", "06"] : [];
    },
    CheckedChange2(value) {
      this.scope_2 = value ? ["11", "12", "13"] : [];
    },
    CheckedChange3(value) {
      this.scope_3 = value ? ["21", "22", "23"] : [];
    },
    addFile(type) {
      if (type === "one") {
        this.addData.file_1.value.push({});
      } else {
        this.addData.file_2.value.push({});
      }
    },
    addTd() {
      this.addData.td.value.push("");
    },
    addAddress() {
      this.address.push({
        proviceCode: "",
        proviceName: "",
        cityCode: "",
        cityName: "",
        areaCode: "",
        areaName: "",
        cityList:[],
        areaList:[],
      });
      this.handleDefaultAddress();
    },
    delAddress(i) {
      this.address.splice(i, 1);
    },
    delTd(i) {
      this.addData.td.value.splice(i, 1);
    },
    async getAttachFileByFid(fid) {
      let res = await axios.get(
        "https://filecenter.huijiaoyun.com/filecenter/upload/getAttachFileByFid/" +
          fid
      );
      console.log("getAttachFileByFid", fid, res);
      return res?.data?.data?.previewUrl;
    },
    getExt(ext) {
      return util.getFileType(ext);
    },
    formatFileSize(limit) {
      limit = limit * 1;
      let size = "";
      if (limit < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      let sizeStr = size + ""; // 转成字符串
      let index = sizeStr.indexOf("."); // 获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou === "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
    handleMaterial(id) {
      if (id === "add") {
        this.$router.push({
          path: "/supervise/material",
          query: { type: "add" },
        });
      } else if (id === "no") {
        this.addData.mid.select = { mid: "", mname: "", auditState: "" };
      } else {
        this.materialList.forEach((item) => {
          if (id === item.mid) {
            this.addData.mid.select = item;
          }
        });
      }
    },
    setCourseType(data){
      this.typeId=data.typeId || ''
      this.typeName=data.typeName || ''
      this.subclassId=data.subclassId || ''
      this.subclassName=data.subclassName || ''
    },
    handleCourseTypeChange(value) {
      this.typeId=''
      this.typeName=''
      this.subclassId=''
      this.subclassName=''
      this.courseTypeData.forEach(it=>{
        if(value[0]==it.value){
           this.typeId=it.value
           this.typeName=it.label
        }
        it.children.forEach(j=>{
           if(value[1]==j.value){
              this.subclassId=j.value
              this.subclassName=j.label
           }
        })
      })
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .top_box {
    width: 100%;
    height: 130px;
    padding: 0px 30px;
  }
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
    }
    .left,
    .right {
      width: 60px;
    }
    // .left {
    //   cursor: pointer;
    // }
  }
  .main {
    padding: 30px;
    position: absolute;
    width: 100%;
    height: calc(100% - 130px);
    overflow: auto;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
      .require::after {
        content: "*";
        color: #f56c6c;
        margin-left: 4px;
      }
    }
    .input-list {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      p {
        width: 90px;
        line-height: 21px;
        font-size: 14px;
        color: #606266;
      }
    }
    .check-title {
      display: inline-block;
      width: 60px;
      color: #606266;
      font-size: 14px;
      padding-left: 3px;
    }
  }
  footer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .table {
    margin-top: 30px;
    border: 1px solid #eee;
    .td-1 {
      width: 15%;
      height: 100%;
      float: left;
      border-right: 1px solid #eee;
    }
    .td-2 {
      width: 85%;
      height: 100%;
      float: right;
    }
    .file {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin: 0 20px;
        }
        span {
          width: 500px;
          text-align: left;
          // 省略号
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .no_temp {
          text-align: center;
          width: 800px;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 10px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 48px;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    width: 100%;
    height: 48px;
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
}

.material-upload {
  .uploadBtnMore {
    width: 80px;
    height: 28px;
    font-size: 13px;
    text-align: center;
    line-height: 28px;
    color: #009dfd;
    border-radius: 15px;
    border: 1px solid #009dfd;
    // cursor: pointer;
    display: inline-block;
    float: left;
    margin-left: 0px;
    span {
      // cursor: pointer;
      display: block;
    }
  }
  .upload-text {
    line-height: 24px;
    color: #999;
    margin-left: 88px;
  }
  .upload-files {
    li {
      display: inline-block;
      position: relative;
      height: 100px;
      width: 150px;
      margin-right: 10px;
      .img {
        max-width: 150px;
      }
      .del {
        position: absolute;
        top: -12px;
        right: -15px;
        cursor: pointer;
        transition: 0s background-color;
      }
      .video-class {
        max-width: 300px;
      }
    }
    .video_li {
      width: 300px !important;
    }
  }
}
.course-box {
  display: flex;
  margin-bottom: 10px;
  p {
    width: 60px;
    color: #999;
  }
}
.flex_start {
  display: flex;
  .one_check {
    margin-right: 30px;
  }
}
.uploadBtnMore_pl {
  width: 120px;
  height: 30px;
  font-size: 13px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  background-color: #169bd5;
  border-radius: 5px;
  // cursor: pointer;
  display: inline-block;
  margin-left: 73%;
  div {
    cursor: pointer;
  }
  span {
    display: block;
  }
}
.Homeboxtop_nav_tab {
  border-bottom: 1.5px solid #eee;
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
} /* chrome */
input[type="number"] {
  -moz-appearance: textfield; /* firefox */
}
.distpicker-address-wrapper select {
  height: 35px;
  width: 200px;
}
</style>
